// Styles
import '../../../../components/screens/quienessomos/us/us.css'
import imgFundadoras from '../../../../assets/img/founders/Fundadoras-madrina.png'

import SubHeading from '../../../subHeading/SubHeading'

const Us = () => {

    return (
        <section className='us section__padding'>
            <div className='us__copy'>
                <SubHeading title='Fundadoras' color={false} />
                <div className='us__text'>
                    <p className='p__main'>La Vida en Rojo, Asociación de Cultura Menstrual, nació en 2021 del encuentro entre mujeres de distintas disciplinas que compartían una misma inquietud: contribuir a transformar la manera en que la sociedad comprende, vive y acompaña la salud, la educación y la equidad menstrual, cíclica y climatérica. Desde una mirada feminista, concibieron la cultura menstrual como un campo de conocimiento, resistencia y transformación capaz de generar cambios en los ámbitos social, comunitario, político y cultural.</p>
                    <p className='p__main'>La asociación fue fundada por Carolina Ackermann Barreiro, M.ª Victoria López Benito y Ana Luisa Meza Ferrari. Desde el inicio dedicaron su tiempo, experiencia y trabajo voluntario a dar forma a un proyecto colectivo que pudo constituirse oficialmente en 2021, una vez superadas las restricciones derivadas del confinamiento. Poco después se incorporó Núria Beitia Hernández, cuya implicación en el cuidado de la asociación y en el sostenimiento de sus procesos ha formado parte de este recorrido compartido.</p>
                    <p className='p__main'>Desde entonces, La Vida en Rojo continúa tejiendo una red de personas, saberes y prácticas comprometidas con la cultura menstrual, manteniendo vivo el propósito que dio origen a la asociación y fortaleciendo una comunidad que entiende los cuidados como una práctica política y transformadora.</p>
                </div>
            </div>

            <div className='us__image-panel'>
                <img
                    src={imgFundadoras}
                    alt='Fundadoras y colaboradora de La Vida en Rojo'
                    loading='lazy'
                />
            </div>

        </section>
    )
}

export default Us
